
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import Cases from "../pages/cases/page";
import Contact from "../pages/contact/page";
import News from "../pages/news/page";
import HRConsulting from "../pages/hr-consulting/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/hr-consulting",
    element: <HRConsulting />,
  },
  {
    path: "/cases",
    element: <Cases />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/news",
    element: <News />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
